import styled from "styled-components";

export const OptInAccordionComponentDefaultBox = styled.div`
    margin-bottom: 24px;
    text-align: left;
    color: #CCCCCC;
    margin: 0px 24px;
`;
